<div class="flex items-center gap-2">
    @if (author()) {
        <div class="h-16 w-16 overflow-hidden rounded-full md:h-20 md:w-20">
            <app-lazy-asset
                class="h-full w-full object-cover"
                [configuration]="imageConfiguration()">
            </app-lazy-asset>
        </div>
        <div>
            <p class="font-heading">
                <span class="text-deemphasized">by</span>
                &nbsp;<span class="font-bold">{{ author().fullName }}</span>
            </p>
        </div>
    }
</div>
